module.exports = __webpack_public_path__ + "static/img/act-2.7c910e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/act-2.png
// module id = BYn3
// module chunks = 5